import Leg from "./Leg";
import LegsList from "./LegsList";

export default LegsList;
export { Leg };
